import axios from 'axios';


export interface AcbListResponse {
    count: number;
    next: string | null; // Assuming "next" can be null if there are no more pages
    previous: string | null; // Assuming "previous" can be null if there is no previous page
    results: AcbListResults[] | undefined;
}


export type AcbListResults = {
    id: number;
    serial_number: string;
    custom_name: string;
    organization_name: string;
    building_name: string;
    client_device_type: string;
    error_count: number;
    manufacture_date: string; // ISO date string
    soh: number;
    energy_ratio: number;
    cycles: number;
    online_dt: string; // ISO date string
    bms_model?: string;
}


export type AcbListParams = {
    search?: string | undefined;
    ordering?: string;
    limit:number;
    offset:number;
    is_manufacture_date: boolean | undefined;
    currentPage: number;
    timeout: NodeJS.Timeout | undefined;
}


function generateQueryString(params: any): string {
    const queryString = Object.entries(params)
        .filter(([key, value]) => value !== undefined) // filter out undefined values
        .map(([key, value]) => {
            if (key === 'offset' && params.limit && params.currentPage) {
                value = (params.currentPage - 1) * params.limit
            }
            if (key === 'currentPage') {
                return null
            }
            return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
        })
        .join('&'); // Join the key-value pairs with '&'

    return queryString ? `?${queryString}` : '';
}


export const defaultParams = (): AcbListParams => {
    return {
        limit: 10,
        offset: 0,
        currentPage: 1,
        timeout: undefined,
        is_manufacture_date: undefined
    }
}


export const fetchAcbList = (
    params: AcbListParams
    , setter: (value: AcbListResponse) => void
    , setLoading: (value: boolean) => void
): void  => {
    axios.get<AcbListResponse>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/acb/list${generateQueryString(params)}`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var details: AcbListResponse = response.data
            setter(details)
            setLoading(false)
        }
    })
    .catch(error => {
        console.error('Error fetching accumulator details:', error);
    });
}